import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import { slug } from 'researcher/helpers/slug';
import { TYPE_EDITING, TYPE_PROMOTION } from 'researcher/domain/product/service';
import { ordersReducer } from './orders';
export var getCurrentPage = createSelector(function (_ref) {
  var dashboard = _ref.dashboard;
  return dashboard.orders.pages;
}, function (_ref2) {
  var dashboard = _ref2.dashboard;
  return dashboard.orders.pagination;
}, function (pages, pagination) {
  return typeof pages[pagination.page] !== 'undefined' ? pages[pagination.page] : null;
});
export var getDigitalOrdersLinkTerm = createSelector(function (_ref3) {
  var digitalOrders = _ref3.digitalOrders;
  return digitalOrders.hasUploadedDigitalEdit;
}, function (_ref4) {
  var digitalOrders = _ref4.digitalOrders;
  return digitalOrders.hasUploadedDigitalTranslation;
}, function (hasUploadedDigitalEdit, hasUploadedDigitalTranslation) {
  if (hasUploadedDigitalEdit && hasUploadedDigitalTranslation) {
    return 'digital-editing-and-digital-translations-links';
  }
  if (hasUploadedDigitalEdit) {
    return 'digital-editing-link';
  }
  if (hasUploadedDigitalTranslation) {
    return 'digital-translations-link';
  }
  return '';
});
export var getOrders = createSelector(getCurrentPage, function (_ref5) {
  var dashboard = _ref5.dashboard;
  return dashboard.orders.entities;
}, function (currentPage, orders) {
  return currentPage ? currentPage.ids.map(function (id) {
    return orders[id];
  }) : [];
});
export var getOrder = createSelector(function (_ref6) {
  var dashboard = _ref6.dashboard;
  return dashboard.orders.entities;
}, function (_ref7) {
  var match = _ref7.match;
  return match.params.externalId;
}, function (orders, externalId) {
  return orders[externalId];
});
export var getShowStyleOfEnglish = createSelector(getOrder, function (order) {
  var _order$services;
  return order === null || order === void 0 || (_order$services = order.services) === null || _order$services === void 0 ? void 0 : _order$services.reduce(function (carry, service) {
    if (service.type === TYPE_PROMOTION) {
      return false;
    }
    return carry;
  }, true);
});
export var getDisplayJournal = createSelector(getOrder, function (_ref8) {
  var user = _ref8.user;
  return user && user.impersonatorIdentity;
}, function (order, isAdmin) {
  return isAdmin || order && (order.hasFigures || order.hasManuscriptFormatting);
});
export var getOrderServices = createSelector(getOrder, function (order) {
  var _order$services2;
  return (_order$services2 = order === null || order === void 0 ? void 0 : order.services) !== null && _order$services2 !== void 0 ? _order$services2 : [];
});
export var getReeditMessageTerm = createSelector(getOrderServices, function (services) {
  var editingService = services.find(function (_ref9) {
    var type = _ref9.type;
    return type === TYPE_EDITING;
  });
  return editingService ? "".concat(slug(editingService.name), "-reedit-message") : '';
});
export var getExcludedFileTypes = createSelector(getOrderServices, function (services) {
  return services.map(function (service) {
    return service.fileType;
  });
});
export var dashboardReducer = combineReducers({
  orders: ordersReducer
});